import Main from './Main.vue'
import List from './components/HistoricoAlteracoes'

export default [{
  path: 'historico-alteracoes',
  name: 'historico.alteracoes',
  component: Main,
  children: [
    {path: '/', component: List, name: 'historico.alteracoes'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/historico-alteracoes/routes.js